import React from 'react';
import { Button, MessageBlock } from './ui';

class SaleFlowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[SaleFlow] Uncaught render error', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <MessageBlock
          tone="error"
          title="No se pudo mostrar este paso"
          actions={
            <Button type="button" variant="primary" onClick={this.handleRetry}>
              Reintentar
            </Button>
          }
        >
          Ocurrió un error inesperado. Podés reintentar este paso sin recargar toda la venta.
        </MessageBlock>
      );
    }

    return this.props.children;
  }
}

export default SaleFlowErrorBoundary;
